var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('va-edit-layout',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.MaterialsForm,{attrs:{"id":_vm.id,"title":_vm.title,"item":_vm.item,"redirect":'edit'}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }